export default __webpack_public_path__ + "static/media/gallery4.34b1615f.jpg";